module.exports = __webpack_public_path__ + "static/media/rewards-icon.f87798f4.svg";